import React, { useState } from 'react';
import { AuthProvider, useAuth } from './auth/AuthContext';
import WorkerView from './views/WorkerView';
import OwnerView from './views/OwnerView';
import CalculatorView from './views/CalculatorView';
import jsjLogo from './assets/jsj-icon.png';
import './App.css';

function AppContent() {
  const calculatorRoutes = ['/calculator', '/estimate', '/quote'];
  const isCalculatorRoute = calculatorRoutes.some((route) =>
    window.location.pathname.startsWith(route)
  );
  const { user, role, loading, login, logout } = useAuth();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  if (isCalculatorRoute) {
    return <CalculatorView />;
  }

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!user) {
    return (
      <div className="login-page">
        <div className="login-card">
          <div className="login-brand">
            <img className="login-logo" src={jsjLogo} alt="JSJ Painting logo" />
            <span className="login-title">JSJ Painting Portal</span>
          </div>
          <form onSubmit={async (e) => {
            e.preventDefault();
            setError('');
            const result = await login(password);
            if (!result.success) {
              setError(result.error || 'Invalid password');
            }
          }}>
            <input
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button type="submit">Login</button>
            {error && <p className="error">{error}</p>}
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      <header>
        <div className="brand">
          <img className="brand-logo" src={jsjLogo} alt="JSJ Painting logo" />
          <div className="brand-text">
            <h1 className="brand-title">JSJ Painting</h1>
            <span className="brand-subtitle">{role === 'owner' ? 'Owner Portal' : 'Worker Portal'}</span>
          </div>
        </div>
        <button onClick={logout}>Logout</button>
      </header>

      <main>
        {role === 'owner' ? <OwnerView /> : <WorkerView />}
      </main>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}
